import InAppMessageEligibilityFlowFactory from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityFlowFactory"
import HackleCore from "../../../core/HackleCore"
import { EvaluationEventRecorder } from "../../../core/internal/evaluation/evalautor/EvaluationEventRecorder"
import { InAppMessageEligibilityRequest } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityRequest"
import { InAppMessageEligibilityEvaluation } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityEvaluation"
import { InAppMessageEligibilityFlow } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityFlowEvaluator"
import { EvaluatorContext } from "../../../core/internal/evaluation/evalautor/Evaluator"
import { InAppMessageEvaluateType } from "./InAppMessageEvaluateType"
import { InAppMessageEligibilityEvaluator } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityEvaluator"

export class InAppMessageEvaluateProcessor {
  constructor(
    private readonly core: HackleCore,
    private readonly flowFactory: InAppMessageEligibilityFlowFactory,
    private readonly eventRecorder: EvaluationEventRecorder
  ) {}

  process(type: InAppMessageEvaluateType, request: InAppMessageEligibilityRequest): InAppMessageEligibilityEvaluation {
    const flow = this.resolveFlow(type, request)
    const evaluator = new InAppMessageEligibilityEvaluator(flow, this.eventRecorder)
    return this.core.inAppMessage(request, EvaluatorContext.create(), evaluator)
  }

  private resolveFlow(
    type: InAppMessageEvaluateType,
    request: InAppMessageEligibilityRequest
  ): InAppMessageEligibilityFlow {
    return type === "TRIGGER"
      ? this.flowFactory.getTriggerFlow()
      : this.flowFactory.getDeliverFlow(request.inAppMessage.evaluateContext?.atDeliverTime ?? false)
  }
}
